import React from 'react';
import './HomeButton.css';

// A small house icon shown to the left of each page title. Clicking it returns
// the user straight to the dashboard. `onClick` is the page's dashboard
// navigation (the same handler the page's back button uses at the top level).
const HomeButton = ({ onClick, title = 'Back to dashboard' }) => (
  <button
    type="button"
    className="home-button"
    onClick={onClick}
    title={title}
    aria-label={title}
  >
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        d="M12 3.172a1.5 1.5 0 0 1 .98.363l7.5 6.43A1.5 1.5 0 0 1 21 11.104V19.5A1.5 1.5 0 0 1 19.5 21H15a1 1 0 0 1-1-1v-4.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V20a1 1 0 0 1-1 1H4.5A1.5 1.5 0 0 1 3 19.5v-8.396a1.5 1.5 0 0 1 .52-1.139l7.5-6.43a1.5 1.5 0 0 1 .98-.363Z"
        fill="currentColor"
      />
    </svg>
  </button>
);

export default HomeButton;
